import { Component, OnInit, EventEmitter, Input, Output, ChangeDetectionStrategy, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-date-first-dow',
  templateUrl: './date-first-dow.component.html',
  styleUrls: ['./date-first-dow.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DateFirstDowComponent implements OnInit {

  private _firstDOW = 0;



  @Input('value')
  public set value(val: number) {
    if(isNaN(val)) this._firstDOW = 0;
    this._firstDOW = val;
  }
  public get value(): number {
    return Number(this._firstDOW);
  }

  @Output() public valueChange = new EventEmitter<number>();


  HandleSelect() {
    this.valueChange.emit(this.value);
  }

  constructor() { }

  ngOnInit(): void {
  }

}
